import React from 'react';

import { Checkbox } from 'antd';

import styled from 'styled-components';

const CheckboxContainer = styled.div`
    display: flex;
    align-items: ${(props) => props.align || 'center'};

    .checkbox {
        margin-right: 4px;
    }

    .ant-checkbox-wrapper.ant-checkbox-wrapper-in-form-item {
        font-size: 0.85rem;
        font-weight: 400;
        text-transform: uppercase;
        color: ${(props) => props.theme.TextColorMuted};
    }
`;

const NwCheckbox = ({ value, text, compact, type, onChange, align, ...other }) => {
    return (
        <CheckboxContainer align={align}>
            <Checkbox className="checkbox" checked={value} onChange={(e) => onChange(e.target.checked)} {...other}>
                {text}
            </Checkbox>
        </CheckboxContainer>
    );
};

export default NwCheckbox;
